import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/crypto/CryptoListClient.tsx");
